import * as angular from 'angular';
import {CommissionPaymentDetailsModel} from "../models/commission-payment-details.model";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {CommissionRequestService} from "./commission-requests.service";
import {CommissionsAlertsService} from "./commissions-alerts.service";
import {IQService} from "angular";
import {CommissionModel} from "../models/commission.model";

export class CommissionsService {

  constructor(private commissionRequestService: CommissionRequestService,
              private bringozLoaderService: BringozLoaderService,
              private $log,
              private $q: IQService,
              private commissionsAlertsService: CommissionsAlertsService) {
  }

  addCredit(payload) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.commissionRequestService.addCredit(payload)
        .then((commission) => {
          this.commissionsAlertsService.addCreditSuccess();
          resolve(commission);
        })
        .catch((error) => {
          this.$log.error(error);
          this.commissionsAlertsService.addCreditError();
          // this.DepotsAlerts.createError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    })
  }

  addDebt(payload) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.commissionRequestService.addDebt(payload)
        .then((commission) => {
          this.commissionsAlertsService.addDebitSuccess();
          resolve(commission);
        })
        .catch((error) => {
          this.$log.error(error);
          this.commissionsAlertsService.addDebitError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    })
  }

  exportCommissions(queryParams, payload) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.commissionRequestService.exportCommissions(queryParams, payload)
        .then((commission) => {
          // this.DepotsAlerts.createSuccess();
          resolve(commission);
        })
        .catch((error) => {
          this.$log.error(error);
          // this.DepotsAlerts.createError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    })
  }

  getTotals(payload) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.commissionRequestService.getTotals(payload)
        .then((commission) => {
          // this.DepotsAlerts.createSuccess();
          resolve(commission);
        })
        .catch((error) => {
          this.$log.error(error);
          // this.DepotsAlerts.createError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    })
  }

  payManually(commissionPaymentDetails: CommissionPaymentDetailsModel, queryParams) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.commissionRequestService.payManually(commissionPaymentDetails, queryParams)
        .then((commission) => {
          this.commissionsAlertsService.PayManuallySuccess();
          resolve(commission);
        })
        .catch((error) => {
          this.$log.error(error);
          this.commissionsAlertsService.PayManuallyError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    })
  }

  pay(payload) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.commissionRequestService.pay(payload)
        .then((commission) => {
          this.commissionsAlertsService.PayManuallySuccess();
          resolve(commission);
        })
        .catch((error) => {
          this.$log.error(error);
          this.commissionsAlertsService.PayManuallyError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    })
  }

  editPrice(commissionId: string, price: number, comment: string) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.commissionRequestService.editPrice(commissionId, price, comment)
        .then((commission) => {
          this.commissionsAlertsService.updateSuccess();
          resolve(commission);
        })
        .catch((error) => {
          this.$log.error(error);
          this.commissionsAlertsService.updateError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    })
  }

  bulkEditPrice(query: any, price: number, comment: string) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.commissionRequestService.bulkEditPrice(query, price, comment)
        .then((commissions) => {
          this.commissionsAlertsService.updateSuccess();
          resolve(commissions);
        })
        .catch((error) => {
          this.$log.error(error);
          this.commissionsAlertsService.updateError();
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    })
  }

  deleteOne(id: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.commissionRequestService.deleteOne(id)
      .then((res) => {
        this.commissionsAlertsService.deleteSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.commissionsAlertsService.deleteError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateOne(commission: CommissionModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.commissionRequestService.updateOne(commission)
      .then((res) => {
        this.commissionsAlertsService.updateSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.commissionsAlertsService.updateError();
        deferred.reject(error)
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  getLogsTimeline(commissionId: string) {
    this.bringozLoaderService.on();
    return this.commissionRequestService.getLogsTimeline(commissionId)
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }


}

angular
  .module('bringoz.admin.commissions')
  .service('commissionsService', CommissionsService);
